module.exports = __webpack_public_path__ + "static/media/clutchLogin.456ff711.webp";